// src/components/Login.js
import React, { useEffect } from 'react';
import { signInWithGoogle } from '../lib/supabase';
import { useHistory } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import './Login.css';

const Login = () => {
  const history = useHistory();
  const { isSessionStored } = useAuth();

  // Redirect to home if session exists upon component mount
  useEffect(() => {
    const checkSessionAndRedirect = async () => {
      const sessionExists = await isSessionStored();
      if (sessionExists) {
        history.push('/');
      }
    };
    checkSessionAndRedirect();
  }, [isSessionStored, history]);

  const handleGoogleLogin = async () => {
    const { error } = await signInWithGoogle();
    if (error) {
      // Optionally, handle the error by showing a message to the user
      setErrorMessage('Failed to sign in with Google. Please try again.');
      console.error('Error signing in with Google:', error);
    }
  };

  return (
    <div className="login-page">
      <div className="login-container">
        <div className="login-card">
          <div className="login-header">
            <div className="brand">
              <img 
                src="/images/angry_avatar.png" 
                alt="Stupid Sales Logo" 
                className="brand-logo"
              />
              <div className="brand-text">
                <span className="brand-name">Stupid</span>
                <span className="brand-time">Sales</span>
              </div>
            </div>
            <h1>Welcome Back</h1>
            <p className="subtitle">Sign in to manage your availability and settings</p>
          </div>
          
          <button 
            onClick={handleGoogleLogin}
            className="google-sign-in-button"
          >
            <img 
              src="/images/google-icon.png" 
              alt="Google" 
              className="google-icon" 
            />
            <span>Continue with Google</span>
          </button>
        </div>
      </div>
    </div>
  );
};

export default Login;